import { Record as ImmutableRecord } from 'immutable'
import { AuthAction, AuthActions } from 'lib/actions/auth'
import rpcCacheProxy from 'lib/reducers/proxies'
import { GetReturn, initialGetReturn, Status } from 'lib/rpc'
import { IntrospectResponse } from 'pbts/c1/api/auth/v1/auth'

export type AuthStateRecord = {
    item: GetReturn<IntrospectResponse>
}
export class AuthState extends ImmutableRecord<AuthStateRecord>({ item: initialGetReturn<IntrospectResponse>() }) { }

export const initialAuthState: AuthState = new AuthState()
export const initialCachedAuthState: AuthState = rpcCacheProxy<AuthStateRecord, AuthState>(
    initialAuthState,
    Status.OK,
)()

export const AuthReducer = (state: AuthState, action: AuthActions): AuthState => {
    switch (action.type) {
        case AuthAction.introspect:
            return state.set('item', action.payload)
        // no default
    }
}
